<template>
  <div v-if="!loadingData" color="secondary">
    <q-input
      ref="input"
      :input-class="`${inputClasses}`"
      v-bind="$attrs"
      :value="data"
      dense
      :type="inputType"
      @click="handleClick"
      @input="handleChange"
      @blur="$emit('blur', $event)"
    >
      <template v-slot:prepend>
        <template v-if="icon">
          <a :href="`rcmobile://call?number=${data}`" v-if="type === 'tel'">
            <q-icon :name="icon" color="primary" class="cursor-pointer" />
          </a>
          <q-icon :name="icon" color="inherit" v-else />
        </template>
        <template v-if="text">
          <!-- <a :href="`rcmobile://call?number=${data}`" style="text-decoration: none; min-width: 5rem; padding-bottom: 8px;" v-if="type === 'tel' && !disablePhoneCall"> -->
          <span
            v-if="type === 'tel' && !disablePhoneCall"
            class="cursor-pointer text-subtitle2"
            :class="`${
              textColor ? `text-${textColor}` : 'text-primary'
            } ${textClasses}`"
            style="min-width: 5rem"
            @click="handleDialPhone"
          >
            {{ text }}
            <q-icon :name="telIcon" />
          </span>
          <!-- </a> -->
          <span
            v-else
            class="text-subtitle2"
            :class="`${textColor ? `text-${textColor}` : ''} ${textClasses}`"
            style="min-width: 5rem"
          >
            {{ text }}
          </span>
        </template>
      </template>
      <template v-slot:append>
        <div v-if="type == 'date'">
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date :value="data" :mask="dateMask" @input="handleChange">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Close" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </div>
        <slot name="append"></slot>
      </template>
    </q-input>
  </div>
  <div class="q-py-xs" v-else>
    <q-skeleton type="rect" height="32px" animation="fade" />
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    loadingData: Boolean,
    data: [String, Number],
    name: String,
    icon: String,
    text: String,
    textColor: String,
    textClasses: {
      type: String,
      default: () => ''
    },
    inputClasses: {
      type: String,
      default: () => ''
    },
    telIcon: {
      type: String,
      default: () => 'phone'
    },
    type: {
      type: String,
      default: () => 'text'
    },
    dateDisplayFormat: {
      type: String,
      default: () => ''
    },
    disablePhoneCall: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    inputType() {
      return this.type !== 'date' ? this.type : 'text';
    },
    dateMask() {
      return this.dateDisplayFormat === 'US' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
    }
  },
  data() {
    return {
      localData: this.data
    };
  },
  methods: {
    handleChange(value) {
      this.$emit('input', { name: this.name, model: value });
    },
    handleDialPhone() {
      window.open(`rcmobile://call?number=${this.data}`);
    },
    handleClick() {
      if (this.type === 'date') {
        this.$refs.qDateProxy.toggle();
      }
    }
  }
};
</script>
